import { FC } from 'react';
import React from 'react';
import styles from './Heading.module.scss';

interface HeadingProps {
  type?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  children: React.ReactNode;
  className?: string;
}

export const Heading: FC<HeadingProps> = ({
  type = 'h1',
  children,
  className = '',
}) =>
  React.createElement(
    type,
    { className: `${styles[type]} ${className}` },
    children
  );
